export function useProductFeedback() {
  const feedBackStore = useFeedbackStore();

  const reviewsTotalCountPluralized = computed(() => {
    const total = feedBackStore.reviewsPagination?.total ?? 0;

    return total > 0 ? `${total} ${getNoun(total, 'отзыв', 'отзыва', 'отзывов')}` : 'Нет отзывов';
  });

  const questionsTotalCountPluralized = computed(() => {
    const total = feedBackStore.questionsPagination?.total ?? 0;

    return total > 0 ? `${total} ${getNoun(total, 'вопрос', 'вопроса', 'вопросов')}` : 'Нет вопросов';
  });

  const averageRating = computed(() => {
    const reviews = feedBackStore.reviews;

    if (reviews.length) {
      const ratings = reviews.map((review) => review.rating);

      return (ratings.reduce((a, b) => a + b) / ratings.length).toFixed(1);
    }
    return '0.0';
  });

  function getReviewsCountByRating(rating: number) {
    const reviews = feedBackStore.reviews;

    return reviews.filter((review) => review.rating === rating).length;
  }

  return {
    reviewsTotalCountPluralized,
    questionsTotalCountPluralized,
    averageRating,
    getReviewsCountByRating,
  };
}
